export const DEFAULT_REMINDER_VALUES = {
    PUNCH_IN: {
        enabled: false,
        send_after: "15",
        delivery_method: "chat",
        repeat_every: "15",
        repeat_count: "1",
        message: `Hello [Driver First Name], it appears you have not punched in today. Please verify in your payroll app, and remember that your scheduled start time was [Scheduled Start Time] or your Load Out inspection start time was at [Load Out Time]. Thank you!`,
    },

    BREAK_IN: {
        enabled: false,
        send_after: "1",
        send_after_unit: "hour",
        delivery_method: "chat",
        repeat_every: "15",
        repeat_count: "1",
        message: `Hello [Driver First Name], it appears you have not punched back in from your lunch break. Please verify on your payroll app. Thank you!`,
    },

    BREAK_OUT: {
        enabled: false,
        send_after: "15",
        delivery_method: "chat",
        repeat_every: "15",
        repeat_count: "1",
        message: `Hello [Driver First Name], it appears you have not yet punched out for your lunch break. Please verify on your payroll app. Thank you!`,
    },

    PUNCH_OUT: {
        enabled: false,
        send_after: "15",
        delivery_method: "chat",
        repeat_every: "15",
        repeat_count: "1",
        message: `Hello [Driver First Name], it appears you have not punched out today. Please verify on your payroll app and remember that your RTS Completion time was [RTS Completion time], or your Flex logout time was [Flex logout time]. Thank you!`,
    },
};

export const MINUTES_OPTIONS = [
    { name: "15", value: "15" },
    { name: "20", value: "20" },
    { name: "25", value: "25" },
    { name: "30", value: "30" },
    { name: "35", value: "35" },
    { name: "40", value: "40" },
    { name: "45", value: "45" },
    { name: "50", value: "50" },
    { name: "55", value: "55" },
    { name: "60", value: "60" },
];

export const HOURS_OPTIONS = [
    { name: "1", value: "1" },
    { name: "2", value: "2" },
    { name: "3", value: "3" },
    { name: "4", value: "4" },
];

export const REPEAT_COUNT_OPTIONS = [
    { name: "1", value: "1" },
    { name: "2", value: "2" },
    { name: "3", value: "3" },
    { name: "4", value: "4" },
    { name: "5", value: "5" },
];

export const REMINDER_CARDS = [
    {
        reminderId: 'punch-in',
        title: "Punch In Reminder",
        description: "Alert driver when no punch-in is detected after scheduled start time",
        type: "PUNCH_IN",
        sendAfterText: "min after scheduled start or Load out completion",
        sendAfterOptions: MINUTES_OPTIONS
    },
    {
        reminderId: 'break-in',
        title: "Break In Reminder",
        description: "Alert driver when no break-in punch is detected",
        type: "BREAK_IN",
        sendAfterText: "hrs after scheduled start",
        sendAfterOptions: HOURS_OPTIONS
    },
    {
        reminderId: 'break-out',
        title: "Break Out Reminder",
        description: "Alert driver when no return-from-break punch is detected",
        type: "BREAK_OUT",
        sendAfterText: "min after lunch-out punch",
        sendAfterOptions: MINUTES_OPTIONS
    },
    {
        reminderId: 'punch-out',
        title: "Punch Out Reminder",
        description: "Alert driver when no punch-out is detected after shift end or RTS completion",
        type: "PUNCH_OUT",
        sendAfterText: "min after scheduled end or RTS completion",
        sendAfterOptions: MINUTES_OPTIONS
    },
];

export const PUNCH_REMINDERS_VARIABLES = [
    '[Driver First Name]',
    '[Scheduled Start Time]',
    '[Scheduled End Time]',
    '[Load Out Time]',
    '[RTS Completion time]',
    '[Flex logout time]',
]
